import React from 'react'
import { Modal, Button } from 'antd'
import { injectIntl } from 'react-intl'
import Commissions from './Comissions'
import style from './style.module.scss'

class CommissionsModal extends React.Component {
  state = {
    visible: false,
  }

  onShow = () => this.setState({ visible: true })

  onClose = () => this.setState({ visible: false })

  render() {
    const { visible } = this.state
    const { intl: { formatMessage }, buttonProps } = this.props;

    return (
      <>
        <Button
          onClick={this.onShow}
          className={this.props.className}
          icon={this.props.icon || null}
          {...buttonProps}
        >
          {this.props.title}
        </Button>
        <Modal
          className={style.modal}
          title={formatMessage({ id: 'components.commissions-modal.title' })}
          visible={this.state.visible}
          footer={null}
          onCancel={this.onClose}
          afterClose={this.resetState}
        >
          {visible && <Commissions {...this.props} />}
        </Modal>
      </>
    )
  }
}

export default injectIntl(CommissionsModal)
